import { markupTemplateLang } from "./shared"

markupTemplateLang("ftl", {
	block: ["<#--", "-->"],
})
